import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { MdHistory, MdEdit } from 'react-icons/lib/md';
import _ from 'lodash';
import { mediumModalStyle } from '../../constants';
import { fetchPermissions} from '../../actions/project_actions';
import { fetchContractManagementDetails } from '../../actions/additional_actions';
import { withAuth } from '../../actions/';
import ReadOnlyContractManagementDetails from './ReadOnlyContractManagementDetails';
import ContractManagementDetailsForm from './ContractManagementDetailsForm';
import { fetchPermissionsByModule } from '../../actions/project_actions';
import { getDateValue } from '../../utils/date';
import { MdList } from 'react-icons/lib/md';

class ContractManagementDetails extends Component {

    // static PropTypes = {
    //     cmDetail: PropTypes.array.isRequired,
    //     permissions: PropTypes.object.isRequired
    // }

    constructor(props) {
        super(props);
        this.state = {
            contract: {},
            isEditable: false,
            isLoading: false,
            modalVisible: false,
            logsList: [],
            cmDetail: {},
            emptycmDetail: {
                id: -1,
                projectId: this.props.contract.projectId,
                cntrctId: this.props.contract.contractId,
                prjctdCnstrctnStrtDt: '',
                actSubstntlCmpltnDt: '',
                substntlInspcDt: '',
                prjctdSubstntlInspcDt: '',
                punchLst: false,
                grntStrtDt: '',
                grntEndDt: '',
                finalInspctnDt: '',
                finalCompltnDt: '',
                cntrctClsoutDt: '',
                createdBy: '',
                createdDt: '',
                isActive: false,
                modifiedBy: '',
                modifiedDt: '',
                comments: '',

            }
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleEditable = this.toggleEditable.bind(this);
        this.setData = this.setData.bind(this);
        this.showLog = this.showLog.bind(this);
        this.onDone = this.onDone.bind(this);
        this.handleLog = this.handleLog.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { contract } = this.props;
        this.props.fetchContractManagementDetails(contract.projectId, contract.contractId);
        this.props.fetchPermissions(contract.projectId);
        this.props.fetchPermissionsByModule(this.props.projectId);

    }
    componentDidUpdate(prevProps) {
        if (prevProps.contract.contractId !== this.props.contract.contractId) {
            this.props.fetchContractManagementDetails(this.props.contract.projectId, this.props.contract.contractId);
            this.props.fetchPermissions(this.props.contract.projectId);
        }
        if (prevProps.cmDetail !== this.state.cmDetail) {
            this.props.fetchContractManagementDetails(this.props.contract.projectId, this.props.contract.contractId);
            this.props.fetchPermissions(this.props.contract.projectId);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.cmDetail !== nextProps.cmDetail)
            this.setState({ cmDetail: nextProps.cmDetail })
        if (this.props.contract.contractId !== nextProps.contract.contractId)
            this.setState({ contract: nextProps.contract })
    }

    showLog() {
        this.handleLog();
    }

    onDone() {
        this.setState({ modalVisible: false });
    }

    toggleEditable() {
        this.setState({ isEditable: !this.state.isEditable });
    }

    setData() {
        this.setState({ isEditable: !this.state.isEditable });
        this.setState({
            cmDetail: {
                id: -1,
                projectId: this.props.contract.projectId,
                cntrctId: this.props.contract.contractId,
                prjctdCnstrctnStrtDt: '',
                actSubstntlCmpltnDt: '',
                substntlInspcDt: '',
                prjctdSubstntlInspcDt: '',
                punchLst: false,
                grntStrtDt: '',
                grntEndDt: '',
                finalInspctnDt: '',
                finalCompltnDt: '',
                cntrctClsoutDt: '',
                createdBy: '',
                createdDt: '',
                isActive: false,
                modifiedBy: '',
                modifiedDt: '',
                comments: '',
            }
        })
    }

    handleSubmit(cmDetail) {
        const url = `/projects/${cmDetail.projectId}/contractManagementDetails/${cmDetail.cntrctId}`;
        return withAuth(
            { method: 'post', url: url, data: cmDetail },
            () => {
                this.toggleEditable();
                this.props.saveInfo(cmDetail);
                this.setState({ CMDVisible: false });
                this.props.sendData();
                this.setState({ cmDetail: cmDetail });
                // this.props.fetchContractManagementDetails(cmDetail.projectId, cmDetail.contractId);
                this.setState({ isLoading: false });
            }
        );
    }

    handleLog() {

        const projectId = this.props.contract.projectId;
        const cntrctId = this.props.contract.contractId;

        let url = `projects/${projectId}/contractManagementDetailsLog/${cntrctId}`;
        let method = 'get';


        return withAuth(
            { method, url },
            (response) => {
                var data = response.data;
                this.setState({ modalVisible: true, logsList: data.entries });
            },
            this.errorHandler
        )
    }

    renderTable(logsList) {
        return (
            <div className="dw-table">
                {this.props.contract.contractType.includes('Force Account/') ?
                    <table className="table-striped">
                        <thead>
                            <tr>
                                <th>Contract Close Out</th>
                                <th>Created By</th>
                                <th>Created Date</th>
                                <th>Modified By</th>
                                <th>Modified Date</th>
                            </tr>
                        </thead>
                        <tbody>

                            {_.orderBy(logsList, ['createdDate'], ['desc']).map(log =>
                                <tr key={log.id}>
                                    <td>{getDateValue(log.cntrctClsoutDt)}</td>
                                    <td>{log.createdBy}</td>
                                    <td>{getDateValue(log.createdDt)}</td>
                                    <td>{log.modifiedBy}</td>
                                    <td>{getDateValue(log.modifiedDt)}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    : null}
                {this.props.contract.contractType.includes('Construction/') ?
                    <div>
                        {this.props.contract.divisionName === 'Infrastructure' ?
                            <div>
                                <table className="table-striped">
                                    <thead>
                                        <tr>
                                            <th>Substantial Inspection</th>
                                            <th>Actual Substantial Completion</th>
                                            <th>Final Completion</th>
                                            <th>Contract Close Out</th>
                                            <th>Created By</th>
                                            <th>Created Date</th>
                                            <th>Modified By</th>
                                            <th>Modified Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {_.orderBy(logsList, ['createdDate'], ['desc']).map(log =>
                                            <tr key={log.id}>
                                                <td>{getDateValue(log.substntlInspcDt)}</td>
                                                <td>{getDateValue(log.actSubstntlCmpltnDt)}</td>
                                                <td>{getDateValue(log.finalCompltnDt)}</td>
                                                <td>{getDateValue(log.cntrctClsoutDt)}</td>
                                                <td>{log.createdBy}</td>
                                                <td>{getDateValue(log.createdDt)}</td>
                                                <td>{log.modifiedBy}</td>
                                                <td>{getDateValue(log.modifiedDt)}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div>
                                <table className="table-striped">
                                    <thead>
                                        <tr>
                                            <th>Projected Construction Start</th>
                                            <th>Actual Construction State</th>
                                            <th>Substantial Inspection</th>
                                            <th>Projected Substantial Completion</th>
                                            <th>Actual Substantial Completion</th>
                                            <th>Punch List</th>
                                            <th>Guarantee Start</th>
                                            <th>Guarantee End</th>
                                            <th>Final Inspection</th>
                                            <th>Final Completion</th>
                                            <th>Contract Close Out</th>
                                            <th>Created By</th>
                                            <th>Created Date</th>
                                            <th>Modified By</th>
                                            <th>Modified Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {_.orderBy(logsList, ['createdDate'], ['desc']).map(log =>
                                            <tr key={log.id}>
                                                <td>{getDateValue(log.prjctdCnstrctnStrtDt)}</td>
                                                <td>{getDateValue(log.actCnstrctnStrtDt)}</td>
                                                <td>{getDateValue(log.substntlInspcDt)}</td>
                                                <td>{getDateValue(log.prjctdSubstntlInspcDt)}</td>
                                                <td>{getDateValue(log.actSubstntlCmpltnDt)}</td>
                                                <td>{log.punchLst ? 'Yes' : 'No'}</td>
                                                <td>{getDateValue(log.grntStrtDt)}</td>
                                                <td>{getDateValue(log.grntEndDt)}</td>
                                                <td>{getDateValue(log.finalInspctnDt)}</td>
                                                <td>{getDateValue(log.finalCompltnDt)}</td>
                                                <td>{getDateValue(log.cntrctClsoutDt)}</td>
                                                <td>{log.createdBy}</td>
                                                <td>{getDateValue(log.createdDt)}</td>
                                                <td>{log.modifiedBy}</td>
                                                <td>{getDateValue(log.modifiedDt)}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        }
                    </div> : null}


                {(!this.props.contract.contractType.includes('Construction/') && !this.props.contract.contractType.includes('Force Account/')) ?
                    <div>
                        {this.props.contract.divisionName === 'Public Buildings' ?
                            <div>
                                {this.props.contract.contractType.includes('/JOCS/') ?
                                    <div>
                                        <table className="table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Projected Construction Start</th>
                                                    <th>Actual Construction State</th>
                                                    <th>Substantial Inspection</th>
                                                    <th>Projected Substantial Completion</th>
                                                    <th>Actual Substantial Completion</th>
                                                    <th>Punch List</th>
                                                    <th>Guarantee Start</th>
                                                    <th>Guarantee End</th>
                                                    <th>Final Inspection</th>
                                                    <th>Final Completion</th>
                                                    <th>Contract Close Out</th>
                                                    <th>Created By</th>
                                                    <th>Created Date</th>
                                                    <th>Modified By</th>
                                                    <th>Modified Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {_.orderBy(logsList, ['createdDate'], ['desc']).map(log =>
                                                    <tr key={log.id}>
                                                        <td>{getDateValue(log.prjctdCnstrctnStrtDt)}</td>
                                                        <td>{getDateValue(log.actCnstrctnStrtDt)}</td>
                                                        <td>{getDateValue(log.substntlInspcDt)}</td>
                                                        <td>{getDateValue(log.prjctdSubstntlInspcDt)}</td>
                                                        <td>{getDateValue(log.actSubstntlCmpltnDt)}</td>
                                                        <td>{log.punchLst ? 'Yes' : 'No'}</td>
                                                        <td>{getDateValue(log.grntStrtDt)}</td>
                                                        <td>{getDateValue(log.grntEndDt)}</td>
                                                        <td>{getDateValue(log.finalInspctnDt)}</td>
                                                        <td>{getDateValue(log.finalCompltnDt)}</td>
                                                        <td>{getDateValue(log.cntrctClsoutDt)}</td>
                                                        <td>{log.createdBy}</td>
                                                        <td>{getDateValue(log.createdDt)}</td>
                                                        <td>{log.modifiedBy}</td>
                                                        <td>{getDateValue(log.modifiedDt)}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    :
                                    <div>
                                        <table className="table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Contract Close Out</th>
                                                    <th>Created By</th>
                                                    <th>Created Date</th>
                                                    <th>Modified By</th>
                                                    <th>Modified Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {_.orderBy(logsList, ['createdDate'], ['desc']).map(log =>
                                                    <tr key={log.id}>
                                                        <td>{getDateValue(log.cntrctClsoutDt)}</td>
                                                        <td>{log.createdBy}</td>
                                                        <td>{getDateValue(log.createdDt)}</td>
                                                        <td>{log.modifiedBy}</td>
                                                        <td>{getDateValue(log.modifiedDt)}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>}
                            </div>
                            :
                            <div>
                                {this.props.contract.contractType.includes('/JOCS/') ?
                                    <div>
                                        <table className="table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Substantial Inspection</th>
                                                    <th>Contract Close Out</th>
                                                    <th>Created By</th>
                                                    <th>Created Date</th>
                                                    <th>Modified By</th>
                                                    <th>Modified Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {_.orderBy(logsList, ['createdDate'], ['desc']).map(log =>
                                                    <tr key={log.id}>
                                                        <td>{getDateValue(log.substntlInspcDt)}</td>
                                                        <td>{getDateValue(log.cntrctClsoutDt)}</td>
                                                        <td>{log.createdBy}</td>
                                                        <td>{getDateValue(log.createdDt)}</td>
                                                        <td>{log.modifiedBy}</td>
                                                        <td>{getDateValue(log.modifiedDt)}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div> : 
                                <div>
                                <table className="table-striped">
                                    <thead>
                                        <tr>                                           
                                            <th>Contract Close Out</th>
                                            <th>Created By</th>
                                            <th>Created Date</th>
                                            <th>Modified By</th>
                                            <th>Modified Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {_.orderBy(logsList, ['createdDate'], ['desc']).map(log =>
                                            <tr key={log.id}>                                               
                                                <td>{getDateValue(log.cntrctClsoutDt)}</td>
                                                <td>{log.createdBy}</td>
                                                <td>{getDateValue(log.createdDt)}</td>
                                                <td>{log.modifiedBy}</td>
                                                <td>{getDateValue(log.modifiedDt)}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                                }
                            </div>
                        }
                    </div>
                    : null}


            </div>
        )
    }

    render() {
      
        const { cmDetail, permissions } = this.props;

        const { contract } = this.props;
        const { isEditable, isLoading } = this.state;
        const { isCSUDir } = this.props.permissionsModule;

        const { roleModules } = permissions.editPrivileges;

        const canShowForm = (roleModules !== null && roleModules.includes('Project Info') && isEditable && !isLoading && !this.props.contract.contractType.includes('Force Account/')) || (this.props.contract.contractType.includes('Force Account/') && isCSUDir && isEditable && !isLoading)
            ? true : false;
        const canShowButtons = ((roleModules !== null && roleModules.includes('Project Info') && this.props.contract.contractStatus === 'Active Contract' && !isLoading && !this.props.contract.contractType.includes('Force Account/') && this.props.contract.contractType.includes('Construction/'))
            || (roleModules !== null && roleModules.includes('Project Info') && this.props.contract.contractStatus === 'Active Contract' && !isLoading && !this.props.contract.contractType.includes('Force Account/') && !this.props.contract.contractType.includes('Construction/') && this.props.contract.divisionName === 'Infrastructure'  && !this.props.contract.contractType.includes('/JOCS/') && isCSUDir)
            || (roleModules !== null && roleModules.includes('Project Info') && this.props.contract.contractStatus === 'Active Contract' && !isLoading && !this.props.contract.contractType.includes('Force Account/') && !this.props.contract.contractType.includes('Construction/') && this.props.contract.divisionName === 'Infrastructure'  && this.props.contract.contractType.includes('/JOCS/'))
            || (roleModules !== null && roleModules.includes('Project Info') && this.props.contract.contractStatus === 'Active Contract' && !isLoading && !this.props.contract.contractType.includes('Force Account/') && !this.props.contract.contractType.includes('Construction/') && this.props.contract.divisionName !== 'Infrastructure'  && this.props.contract.contractType.includes('/JOCS/'))
            || (roleModules !== null && roleModules.includes('Project Info') && this.props.contract.contractStatus === 'Active Contract' && !isLoading && !this.props.contract.contractType.includes('Force Account/') && !this.props.contract.contractType.includes('Construction/') && this.props.contract.divisionName !== 'Infrastructure'  && !this.props.contract.contractType.includes('/JOCS/') && isCSUDir)
            || (this.props.contract.contractType.includes('Force Account/') && this.props.contract.contractStatus === 'Active Contract'  && roleModules !== null && roleModules.includes('Project Info') && isCSUDir && !isLoading))
            ? true : false;

        const className = 'row-wide project-info' + (isEditable ? ' editable' : '');

        return (
            <div>

                {this.state.modalVisible
                    && <Modal
                        isOpen={this.state.modalVisible}
                        style={mediumModalStyle}
                        contentLabel="Status Log"
                    >
                        <div className="col s12">
                            <h1 className="bar-bottom header">Contract Management Details Log</h1>
                        </div>
                        <div className="modal-form logmodal">
                            <div className="project-detail-comments">
                                <div className="col s12">
                                    {this.state.logsList.length
                                        ? this.renderTable(this.state.logsList)
                                        : <div>This record has no logs yet.</div>}
                                </div>
                            </div>
                        </div>

                        <div className="modal-close" onClick={this.onDone}>
                            <span className="close"></span>
                        </div>
                    </Modal>
                }
                {cmDetail.length > 0 ?
                    <div id="accordiondetails" className="row-wide">
                    </div> : null}

                {cmDetail.length > 0 ?
                    <div>
                        <div id="info" className={className}>

                            <div>

                                <h4 className="bar-bottom header margin-bottom-175 detailicons">
                                    {canShowButtons ?
                                        <div >
                                            <span className='margin-right-0325' id='greyColor'><MdList className="fa-Icon" size={20} /></span>
                                            Contract Management Details
                                            <span className='fa-Icon-History' onClick={() => this.showLog()}><MdHistory size={22} color='#8492a6' /></span>
                                            <span className='fa-Icon-Edit' onClick={this.toggleEditable}><MdEdit size={22} color='#8492a6' /></span>
                                        </div>
                                        : <div><span className='margin-right-0325' id='greyColor'><MdList className="fa-Icon" size={20} /></span>
                                            Contract Management Details </div>}
                                </h4>
                            </div>


                            {canShowForm && cmDetail.length > 0 ?
                                <ContractManagementDetailsForm
                                    cmDetail={cmDetail[0]}
                                    contract={contract}
                                    setup={this.props.setup}
                                    onSubmit={this.handleSubmit}
                                    onCancel={this.toggleEditable}

                                />
                                : <ReadOnlyContractManagementDetails
                                    contract={contract}
                                />
                            }

                            {isLoading ? <div className="loader" /> : null}
                        </div>
                    </div>
                    :
                    <div>
                        <div id="info" className={className}>

                            <div>

                                <h4 className="bar-bottom header margin-bottom-175 detailicons">
                                    {canShowButtons ?
                                        <div >
                                            <span className='margin-right-0325' id='greyColor'><MdList className="fa-Icon" size={20} /></span>
                                            Contract Management Details
                                            <span className='fa-Icon-History' onClick={() => this.showLog()}><MdHistory size={22} color='#8492a6' /></span>
                                            <span className='fa-Icon-Edit' onClick={this.toggleEditable}><MdEdit size={22} color='#8492a6' /></span>
                                        </div>
                                        : <div><span className='margin-right-0325' id='greyColor'><MdList className="fa-Icon" size={20} /></span>
                                            Contract Management Details </div>}
                                </h4>
                            </div>


                            {canShowForm ?
                                <ContractManagementDetailsForm
                                    cmDetail={this.state.emptycmDetail}
                                    contract={contract}
                                    setup={this.props.setup}
                                    onSubmit={this.handleSubmit}
                                    onCancel={this.toggleEditable}

                                />
                                : <ReadOnlyContractManagementDetails
                                    contract={contract}
                                />
                            }

                            {isLoading ? <div className="loader" /> : null}
                        </div>
                    </div>
                }



            </div>

        );
    }
}

ContractManagementDetails.propTypes = {
    cmDetail: PropTypes.array.isRequired,
    permissions: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        cmDetail: state.additionalProjectsStore.cmDetail,
        projectId: ownProps.projectId,
        permissions: state.projectsStore.permissions,
        permissionsModule: state.projectsStore.permissionsModule,

    };
}

export default connect(mapStateToProps, { fetchContractManagementDetails, fetchPermissions, fetchPermissionsByModule })(ContractManagementDetails);